import { Icon, Tooltip } from '@shopify/polaris'
import { RefreshIcon } from '@shopify/polaris-icons'

export const DunningIcon = ({ children }: DunningIconProps) => (
  <Tooltip content={children} dismissOnMouseOut={false}>
    <Icon source={RefreshIcon} tone="caution" />
  </Tooltip>
)

interface DunningIconProps {
  children: any
}
